import type { TenantFixture } from './types'

/**
 * A second, fictional demo tenant. It exists so the tenant switcher has
 * somewhere to go and so the generators are visibly tenant-agnostic: the same
 * code produces a smaller business with a different channel mix.
 */
export const demoNorthfield: TenantFixture = {
  id: 'demo_northfield',
  name: 'Northfield Prize Draws',
  seed: 4211,
  currency: 'GBP',
  locale: 'en-GB',
  accentColor: null,
  user: { name: 'Alex Morgan', email: 'alex.morgan@example.com', role: 'owner' },
  websites: [
    { id: 'web_nf_prod', name: 'northfielddraws.example', environment: 'production', trafficShare: 1 },
  ],
  traffic: {
    dailyVisitors: 1100,
    weekdayFactors: [1.1, 0.94, 0.95, 0.97, 1.01, 1.05, 1.12],
    dailyGrowth: 0.002,
  },
  funnelRates: {
    competition_viewed: 0.7,
    ticket_selector_used: 0.55,
    add_to_basket: 0.6,
    checkout_started: 0.7,
    payment_attempted: 0.86,
    purchase_completed: 0.94,
  },
  commerce: {
    ticketsPerOrder: 3.8,
    customersPerOrder: 0.9,
    newCustomerShare: 0.28,
    attributedShare: 0.5,
    unlistedDemandWeight: 1.2,
  },
  devices: [
    { id: 'mobile', label: 'Mobile', share: 0.58 },
    { id: 'desktop', label: 'Desktop', share: 0.35 },
    { id: 'tablet', label: 'Tablet', share: 0.07 },
  ],
  customerTypes: [
    { id: 'new', label: 'New', share: 0.28 },
    { id: 'returning', label: 'Returning', share: 0.72 },
  ],
  competitions: [
    { id: 'nf_campervan', name: 'VW Campervan', category: 'Vehicles', ticketPrice: 2.5, maxEntries: 6000, opensInDays: -14, durationDays: 30, weight: 1.2 },
    { id: 'nf_holiday', name: 'Maldives Holiday', category: 'Travel', ticketPrice: 1.5, maxEntries: 3000, opensInDays: -8, durationDays: 14, weight: 1 },
    { id: 'nf_cash2k', name: '£2,000 Cash', category: 'Cash', ticketPrice: 0.5, maxEntries: 5000, opensInDays: -5, durationDays: 10, weight: 1.1 },
    { id: 'nf_ebike', name: 'Electric Mountain Bike', category: 'Bikes', ticketPrice: 1, maxEntries: 4000, opensInDays: -20, durationDays: 25, weight: 0.4 },
    { id: 'nf_hottub', name: 'Garden Hot Tub', category: 'Home', ticketPrice: 1.25, maxEntries: 2500, opensInDays: -60, durationDays: 45, weight: 0.9 },
    { id: 'nf_watch', name: 'Omega Seamaster', category: 'Watches', ticketPrice: 2, maxEntries: 4000, opensInDays: -70, durationDays: 35, weight: 0.8 },
  ],
  channels: [
    { id: 'meta_ads', name: 'Meta Ads', kind: 'digital', dailySpend: 60, attributionWeight: 0.4, trafficShare: 0.25 },
    { id: 'email', name: 'Email', kind: 'digital', dailySpend: 4, attributionWeight: 0.25, trafficShare: 0.1 },
    { id: 'organic_social', name: 'Organic social', kind: 'digital', dailySpend: 0, attributionWeight: 0.15, trafficShare: 0.15 },
    { id: 'radio', name: 'Local radio', kind: 'offline', dailySpend: 35, attributionWeight: 0.12, trafficShare: 0.02 },
    { id: 'poster', name: 'Posters', kind: 'offline', dailySpend: 8, attributionWeight: 0.08, trafficShare: 0.01 },
  ],
  campaigns: [
    { id: 'nf_camp_summer', name: 'Summer escapes', channels: ['meta_ads', 'email', 'radio'] },
    { id: 'nf_camp_local', name: 'Local heroes', channels: ['organic_social', 'poster'] },
  ],
  creatives: [
    { id: 'nf_cr_radio', name: '30s radio spot', campaignId: 'nf_camp_summer', channel: 'radio' },
    { id: 'nf_cr_video', name: 'Campervan video', campaignId: 'nf_camp_summer', channel: 'meta_ads' },
    { id: 'nf_cr_poster', name: 'Town centre poster', campaignId: 'nf_camp_local', channel: 'poster' },
  ],
  automations: [
    { id: 'nf_auto_basket', name: 'Abandoned basket reminder', status: 'running', trigger: 'Basket abandoned for 2 hours' },
    { id: 'nf_auto_close', name: 'Closing soon email', status: 'running', trigger: '48 hours to close' },
    { id: 'nf_auto_report', name: 'Monthly report', status: 'paused', trigger: 'First of the month' },
  ],
  anomalies: { recentDays: 2, checkoutConversion: 0.97, paymentFailureRate: 0.07 },
}
